/* istanbul ignore file */
import React from 'react';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import { CREATE_JOURNAL_ENTRY } from 'domain/finance/journalEntry/useJournalEntryService';
import { CreateButton } from 'framework/ui/ui-builder';

const CreateJournalEntryButton = ({
  urlParams = '',
  variant,
}: {
  urlParams?: string;
  variant?: 'outlined' | 'contained' | 'text';
}) => {
  const { getCreateUrl } = useJournalEntryUrl();

  return (
    <CreateButton
      url={`${getCreateUrl()}${urlParams}`}
      label="Add journal entry"
      key="create-journal-entry"
      permissionToCheck={CREATE_JOURNAL_ENTRY}
      variant={variant}
    />
  );
};

export default CreateJournalEntryButton;
